import React from 'react';
import { BookOpen, Target, X, Check, Clock, Smartphone, Heart } from 'lucide-react';
export function OfferDetails() {
  return <section className="py-16 md:py-24 bg-cream" data-id="element-91">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
        {/* What You Get */}
        <div className="mb-20" data-id="element-93">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-94">
            Lo que recibirás hoy
          </h2>
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-95">
            <div className="order-2 md:order-1 space-y-4" data-id="element-96">
              {[{
              icon: BookOpen,
              text: "La Guía Completa 'Liberación de Movimiento' en formato PDF."
            }, {
              icon: Clock,
              text: 'El Método 10x10: Una rutina diaria de 10 movimientos en 10 minutos.'
            }, {
              icon: Target,
              text: 'Escáner de Dolor: Herramienta para identificar tus zonas críticas.'
            }, {
              icon: Check,
              text: 'Checklist de Progreso Semanal para mantener tu motivación al máximo.'
            }, {
              icon: Heart,
              text: 'Glosario de salud articular y guía de recursos recomendados.'
            }].map((item, idx) => <div key={idx} className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm border border-sage-light/50" data-id="element-97">
                  <div className="mt-1 bg-sage-light text-sage p-2 rounded-lg" data-id="element-98">
                    <item.icon size={20} data-id="element-99" />
                  </div>
                  <p className="text-lg text-text-dark font-medium" data-id="element-100">
                    {item.text}
                  </p>
                </div>)}
            </div>
            <div className="order-1 md:order-2 relative" data-id="element-101">
              <div className="absolute inset-0 bg-gold/20 rounded-full filter blur-3xl transform translate-x-10 translate-y-10" data-id="element-102"></div>
              <img src="https://cdn.magicpatterns.com/uploads/6fTEZca188hJtU6J1KVC8G/liberacion_de_movimiento.png" alt="Contenido de la guía" className="relative z-10 w-full max-w-md mx-auto rounded-2xl shadow-xl" data-id="element-103" />
            </div>
          </div>
        </div>

        {/* Who is it for / not for */}
        <div className="grid md:grid-cols-2 gap-8 mb-20" data-id="element-104">
          <div className="bg-white rounded-3xl p-8 shadow-card border-t-4 border-sage" data-id="element-105">
            <h3 className="text-2xl font-bold mb-6 flex items-center gap-3" data-id="element-106">
              <span className="bg-sage-light text-sage p-2 rounded-full" data-id="element-107">
                <Check size={24} data-id="element-108" />
              </span>
              Esto ES para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-109">
              {['Eres una mujer de 55+ que siente rigidez al despertar.', 'Quieres seguir siendo independiente y activa.', 'Buscas una solución segura, suave y efectiva para el dolor común.', 'Prefieres ejercitarte en la privacidad y comodidad de tu hogar.'].map((text, idx) => <li key={idx} className="flex items-start gap-3 text-text-muted" data-id="element-110">
                  <Check size={20} className="text-sage mt-1 flex-shrink-0" data-id="element-111" />
                  <span data-id="element-112">{text}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white rounded-3xl p-8 shadow-card border-t-4 border-text-muted/20" data-id="element-113">
            <h3 className="text-2xl font-bold mb-6 flex items-center gap-3" data-id="element-114">
              <span className="bg-gray-100 text-text-muted p-2 rounded-full" data-id="element-115">
                <X size={24} data-id="element-116" />
              </span>
              Esto NO es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-117">
              {['Buscas entrenamientos de alta intensidad o sudar en exceso.', 'Esperas resultados milagrosos sin dedicar al menos 10 minutos al día.', 'Eres atleta profesional o tienes lesiones agudas que requieren cirugía inmediata.'].map((text, idx) => <li key={idx} className="flex items-start gap-3 text-text-muted" data-id="element-118">
                  <X size={20} className="text-text-muted/50 mt-1 flex-shrink-0" data-id="element-119" />
                  <span data-id="element-120">{text}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* How it works */}
        <div data-id="element-121">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-122">
            ¿Cómo funciona?
          </h2>
          <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-123">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-sage-light z-0" data-id="element-124"></div>

            {[{
            step: '1',
            title: 'Descarga',
            desc: 'Descarga la guía PDF en cualquier dispositivo (celular, tablet o computadora).',
            icon: Smartphone
          }, {
            step: '2',
            title: 'Dedica 10 Minutos',
            desc: 'Dedica 10 minutos cada mañana siguiendo la rutina ilustrada del Capítulo 4.',
            icon: Clock
          }, {
            step: '3',
            title: 'Siente el Alivio',
            desc: 'Nota cómo la rigidez desaparece y tu confianza al moverte aumenta día tras día.',
            icon: Heart
          }].map((item, idx) => <div key={idx} className="relative z-10 flex flex-col items-center text-center" data-id="element-125">
                <div className="w-24 h-24 rounded-full bg-white shadow-card flex items-center justify-center mb-6 border-4 border-cream relative" data-id="element-126">
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gold text-white font-bold flex items-center justify-center text-sm" data-id="element-127">
                    {item.step}
                  </div>
                  <item.icon size={32} className="text-sage" data-id="element-128" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-129">{item.title}</h3>
                <p className="text-text-muted" data-id="element-130">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}